export default __webpack_public_path__ + "static/media/indexx token.3e762a6d.png";